module.exports = __webpack_public_path__ + "img/dislike-disabled-big.db3109e1.svg";